import { t } from '@/locale/index.js'
import { applyColumnLabels, applyOptionLabels, applySearchLabels } from '@/utils/listPageI18n.js'

const IMPROVE_COLUMNS = {
  id: 'improveList.taskId',
  title: 'field.title',
  description: 'taskSpecial.description',
  score: 'detail.score',
  status: 'field.status',
  updated_at: 'improveList.startTime',
  created_at: 'improveList.endTime',
  operation: 'table.operation',
}

/** 技能提升任务列表 */
export function applyImproveListLabels({ searchData, columns, statusOptions }) {
  applySearchLabels(searchData, {
    keywords: { labelKey: 'taskSpecial.titleKeyword' },
  })
  applyColumnLabels(columns, IMPROVE_COLUMNS)
  applyOptionLabels(statusOptions, {
    1: 'taskSpecial.published',
    0: 'taskSpecial.unpublished',
  })
}

export { t }
